/**
 * Free plan credit pool display helpers — account wallet vs actor allocation.
 */
import { SAAS_FREE_CREDIT_POOL } from "../constants/saasPlansCatalog";

export const normalizeFreeCreditPool = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  const actors = Array.isArray(raw.actors)
    ? raw.actors.map((row) => ({
      actorId: row?.actorId ?? row?.actor_id ?? null,
      defaultKey: row?.defaultKey || row?.default_key || "",
      actorName: String(row?.actorName || row?.actor_name || "").trim(),
      granted: Number(row?.granted ?? row?.creditsAssigned) || SAAS_FREE_CREDIT_POOL.perDefaultActor,
      available: Math.max(0, Number(row?.available) || 0),
    }))
    : [];
  const account = raw.account && typeof raw.account === "object"
    ? {
      granted: Number(raw.account.granted) || SAAS_FREE_CREDIT_POOL.accountWallet,
      available: Math.max(0, Number(raw.account.available) || 0),
    }
    : {
      granted: SAAS_FREE_CREDIT_POOL.accountWallet,
      available: 0,
    };
  const totalGranted = Number(raw.totalGranted) || SAAS_FREE_CREDIT_POOL.total;
  const totalAvailable = Number.isFinite(Number(raw.totalAvailable))
    ? Math.max(0, Number(raw.totalAvailable))
    : account.available + actors.reduce((sum, row) => sum + row.available, 0);
  return {
    totalGranted,
    totalAvailable,
    account,
    actors,
  };
};

export const formatFreeCreditPoolBreakdown = (pool) => {
  const normalized = normalizeFreeCreditPool(pool);
  if (!normalized) return "";
  const accountPart = `Account ${normalized.account.available}`;
  const actorParts = normalized.actors
    .filter((row) => row.actorName)
    .map((row) => {
      const shortName = row.actorName.replace(/^Default\s+/i, "").replace(/\s+Actor$/i, "");
      return `${shortName} ${row.available}`;
    });
  return [accountPart, ...actorParts].join(" · ");
};

export const freeCreditPoolAllocationNote = () =>
  `${SAAS_FREE_CREDIT_POOL.accountWallet} account + ${SAAS_FREE_CREDIT_POOL.perDefaultActor} per default actor included in Free`;

export default normalizeFreeCreditPool;
